<template>
  <div id="BookingList" class="position-absolute">
    <div class="booking-container" v-click-outside="closeBookings">
      <div class="booking-top d-flex align-items-center justify-content-between">
        <span class="booking-container-title">Your sessions</span>
        <button @click="closeBookings" class="close-button">
          <i class="fa-regular fa-times fa-2x clickable"></i>
        </button>
      </div>
      <template v-if="isLoading">
        <Loader />
      </template>
      <template v-else>
        <div class="d-flex flex-nowrap booking-container-filter-row">
          <button class="booking-container-filter brand-text"
            :class="{ 'booking-selected border-brand-primary': showUpcomingBookings }"
            @click="setShowUpcomingBookings(true)">
            Upcoming
          </button>
          <button class="booking-container-filter brand-text"
            :class="{ 'booking-selected border-brand-primary': !showUpcomingBookings }"
            @click="setShowUpcomingBookings(false)">
            Previous
          </button>
        </div>
        <div class="booking-container-bookings">
          <div v-if="showUpcomingBookings ? upcomingBookings.length > 0 : pastBookings.length > 0">
            <template v-if="showUpcomingBookings">
              <BookingCard v-for="booking in upcomingBookings" :booking="booking"
                :isUpcomingBooking="showUpcomingBookings" />
            </template>
            <template v-else>
              <BookingCard v-for="booking in pastBookings" :booking="booking" />
            </template>
          </div>
          <div class="no-bookings-container" v-else>
            <p class="no-bookings-title brand-text">{{ showUpcomingBookings ? "You don't have any upcoming sessions booked." : "You don't have any past sessions" }}</p>
            <p class="no-bookings-subtitle brand-text">{{ showUpcomingBookings ? "Please note that only services booked through Spectrum.Life will be shown here" : "Please note that only service provided by Spectrum.Life will be shown here" }}</p>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import BookingCard from '../DMH/Booking/BookingCard.vue';
import axios from 'axios';
import config from "../../config/constants";
import moment from 'moment';
import Loader from "@/components/Loader.vue";
import EventBus from "@/helpers/eventbus"

export default {
  name: "BookingList",
  components: {
    BookingCard,
    Loader,
  },
  data() {
    return {
      showUpcomingBookings: true,
      bookings: [],
      upcomingBookings: [],
      pastBookings: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getBookings();
    EventBus.$on("getBookings", this.getBookings);
    this.$store.dispatch("updateIsOverlayVisible", true);
  },
  beforeDestroy(){
    this.$store.dispatch("updateIsOverlayVisible", false);
  },
  methods: {
    closeBookings() {
      this.$emit('close-bookings');
    },
    setShowUpcomingBookings(value) {
      this.showUpcomingBookings = value;
    },
    async getBookings() {
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      const payload = {
        user_id: this.$store.getters.user_id,
      }
      const res = await axios.post(config.api_env + '/application/api/u/dmh/get-all-appointments', payload, config.options)
      this.isLoading = false
      if (res.data.success) {
        this.bookings = res.data.appointments
        let upcomingBookings = [];
        let pastBookings = [];
        res.data.appointments.forEach((app) => {
          if (app.appointmentStatus !== 'Cancelled' && app.appointmentStatus !== 'Cancellation Request') {
            if (!moment().isAfter(moment(app.endTime))) {
              upcomingBookings.push(app);
            } else {
              pastBookings.push(app);
            }
          }
        });
        this.pastBookings = pastBookings.sort((a, b) => {
          const dateA = new Date(a.startTime);
          const dateB = new Date(b.startTime);
          return dateB - dateA;
        });
        this.upcomingBookings = upcomingBookings.sort((a, b) => {
          const dateA = new Date(a.startTime);
          const dateB = new Date(b.startTime);
          return dateA - dateB;
        });
      } else if (res.data.err && res.data.err.includes("3994")) {
        this.$store.dispatch("logout");
        this.$router.push("/login").catch((err) => { });
      }
    },
  },
}
</script>

<style lang="less">
#BookingList {
  display: flex;
  justify-content: flex-end;
  z-index: 1000;
  height: 100vh;
  min-height: 100vh;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  
  .booking-container {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    max-width: 460px;
    background-color: white;
    border: 1px solid lightgrey;
    overflow: scroll;
  
    .booking-top {
      padding: 20px 24px;
    }
  
    .booking-container-title {
      font-size: 2.4rem;
      font-family: "PlusJakartaSansBold";
      font-weight: bold;
    }
  
    .booking-container-filter-row {
      border-top: 1px solid rgba(224, 229, 245, 1);
      font-size: 1.4rem;
      font-family: "PlusJakartaSansRegular";
      font-weight: bold;
      cursor: pointer;
  
      .booking-container-filter {
        display: flex;
        border-width: 0;
        background-color: unset;
        align-items: center;
        justify-content: center;
        font-size: 1.6rem;
        width: 50%;
        height: 100%;
        padding: 24px 12px;
      }

      .booking-selected {
        border-bottom-width: 1px;
        border-bottom-style: solid;
        font-family: "PlusJakartaSansExtraBold";
      }
    }
  
    .booking-container-bookings {
      flex: 1 1 100%;
      border-top: 1px solid rgba(224, 229, 245, 1);
      overflow: auto;
      padding: 24px;
    }
  
    .no-bookings-container {
      display: flex;
      height: 100%;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      font-size: 1.6rem;
  
      b {
        font-family: "PlusJakartaSansBold";
      }
  
      a {
        text-decoration: underline;
      }
  
      .no-bookings-title {
        font-size: 1.8rem;
        line-height: 2.2rem;
        margin-bottom: 20px;
      }
  
      .no-bookings-subtitle {
        font-family: "PlusJakartaSansRegular";
        font-size: 1.6rem;
        line-height: 2.2rem;
      }
    }
  }

  .close-button {
    background-color: rgba(25, 37, 80, 0.05);
    border: 1.5px solid transparent;
    border-radius: 8px;
    width: 48px;
    height: 48px;
    padding: 14px 16px;

    &:hover, &:focus {
      border: 1.5px solid #192550;
    }
  }
}
</style>